
import { Component, Vue } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { mock } from '@/utils/test'
import { getAdvertisinglist } from '@/api/enrollmentinformation'

@Component({
  name: 'advertising',
  components: {
    SimpleTable,
    DictSelect
  }
})
export default class Advertising extends Vue {
  private form: any = {}

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 1
  }

  private columns = [{
    prop: 'thumbnail',
    label: '缩略图',
    custom: !0
  },
  {
    prop: 'agentType',
    label: '代理类型'
  },
  {
    prop: 'position',
    label: '展示位置'
  },
  {
    prop: 'agentState',
    label: '状态',
    custom: !0
  },
  {
    prop: 'user',
    label: '操作者'
  },
  {
    prop: 'date',
    label: '创建时间'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form })
    !pagination && (this.pagination.currentPage = 1)
    await getAdvertisinglist({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
      // this.tableData.list = [(LocalStorage.getObj('addAdvertising') as never)]
      // 持久化测试
      this.tableData = mock.query('addAdvertising', this.tableData, this.form, { ...pagination || this.pagination })
      // const temp: any = LocalStorage.getObj('addAdvertising')
      // if (temp) {
      //   this.tableData = temp
      // }
      // LocalStorage.setObj('addAdvertising', this.tableData)
      // this.tableData.list = this.tableData.list.filter((v: any) => {
      //   const agentType = !this.form.agentType || this.form.agentType === v.agentType
      //   const agentState = !this.form.agentState || this.form.agentState === v.agentState
      //   const position = !this.form.position || this.form.position === v.position
      //   if (agentType && agentState && position) return !0
      // })
      // this.tableData.totalCount = this.tableData.list.length
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
    }
    this.onQuery()
  }

  private edit (tableData: any) {
    this.$router.push({
      name: 'addadvertising',
      params: tableData
    })
  }

  private onAdd () {
    this.$router.push({
      name: 'addadvertising'
    })
  }
}
